import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import * as firebase from 'firebase'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import DateFilter from './filters/date'
import AlertCmp from './components/Shared/Alert.vue'

Vue.config.productionTip = false
Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertCmp)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
  created(){
    firebase.initializeApp({
      // apiKey: "AIzaSyBdpNyeGj7kVTwXUia3I7df0VF5wyrmiLU",
      // authDomain: "sampleproject-916f4.firebaseapp.com",
      // databaseURL: "https://sampleproject-916f4.firebaseio.com",
      // projectId: "sampleproject-916f4",
      // storageBucket: "sampleproject-916f4.appspot.com",
      // messagingSenderId: "586062674118",
      // appId: "1:586062674118:web:3073851f56c870bfe1ffc7"

      apiKey: "AIzaSyA10cwXKhLNlgBmOkCVZCy9CoYO36Gzsys",
      authDomain: "concurrent-backend.firebaseapp.com",
      databaseURL: "https://concurrent-backend.firebaseio.com",
      projectId: "concurrent-backend",
      storageBucket: "concurrent-backend.appspot.com",
      messagingSenderId: "384053919599",
      appId: "1:384053919599:web:f8df4cc41740075523f29a",
      measurementId: "G-76Q2JW334P"

    })

    // firebase.auth().onAuthStateChanged((user) =>{
    //   if(user) {
    //     let userId = firebase.auth().currentUser.uid

    //     let keys
    //         firebase.database().ref('/keys/' + userId).once('value', snapshot => {
    //            keys = snapshot.val()
    //         })

    //        firebase.database().ref('/users/' + userId).once('value', snapshot => {
    //          console.log('snapshot: ', snapshot)
    //          let userDetails = snapshot.val()
    //          this.$store.dispatch('autoSignIn', {
    //            name: userDetails.name,
    //            email: userDetails.email,
    //            id: userId,
    //            username: userDetails.username,
    //            profilePic: userDetails.profilePic,
    //            bio: userDetails.bio,
    //            //publicKey:keys.publicKey,
    //            privKey:userDetails.privKey,
    //            publicKey:userDetails.publicKey,
    //            friendPass: userDetails.friendPass
    //         })
    //         this.$store.dispatch('firebaseGetUsers')
    //         this.$store.dispatch('firebaseGetDMs')
    //         this.$store.dispatch('firebaseGetFriends')
    //         this.$store.dispatch('fetchFeed')
    //         this.$store.dispatch('fetchPrivateFeed')
    //         this.$store.dispatch('firebaseGetPostInteraction')
    //         this.$store.dispatch('firebaseDeletePosts')
    //         this.$store.dispatch('firebaseGetGroupChat')
    //       })
    //   }
    //   else {
    //           //user is logged out
    //           this.dispatch('firebaseUpdateUser', {
    //             id: this.state.user.id,
    //             updates: {
    //               online:false
    //             }
    //           })
    //           // commit('setUser', null)
    //           this.$router.push('/')

    //         }
    // })

    this.$store.dispatch('firebaseGetUsers')
    this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('firebaseGetPostInteraction')
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  }
}).$mount('#app')
